export default __webpack_public_path__ + "static/media/wordcamp.01f3aa4a.jpeg";